import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
const appRoutes: Routes = [
  {path: 'journals', loadChildren: './journals/journals.module#JournalsModule'},
  {path: 'login', loadChildren: './core/login/login.module#LoginModule'},
  {path: '404', loadChildren: './core/page-not-found/page-not-found.module#PageNotFoundModule'},
  {path: '', redirectTo: '', pathMatch: 'full'}
];
@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts